export enum Variant {
  FAVED = 'faved',
  UNFAVED = 'unfaved',
}
